import { isHttpClientError } from 'core/infra/http/HttpClient'

export function isForbiddenCarrierProfileError(error: unknown): boolean {
  if (!isHttpClientError(error)) {
    return false
  }

  return error.response?.status === 403
}
